import { withInstall } from '@jdesign-vue/utils'

import Transfer from './src/transfer.vue'

export const JdTransfer = withInstall(Transfer)
export default JdTransfer

export * from './src/transfer'
